module.exports = __webpack_public_path__ + "fontawesome-webfont.24c601e721ebd8279d38.svg";


//////////////////
// WEBPACK FOOTER
// D:/Works/Safetyminder/Safetyminder/Admin/src/assets/fonts/fontawesome-webfont.svg?v=4.6.3
// module id = ../../../../../src/assets/fonts/fontawesome-webfont.svg?v=4.6.3
// module chunks = styles